export type SessionStorageKey = 'utm_source';

export const setSessionStorage = (key: SessionStorageKey, value: string) => sessionStorage.setItem(key, value);

export const getSessionStorage = (key: SessionStorageKey) => sessionStorage.getItem(key) ?? '';
